// extracted by mini-css-extract-plugin
export default {"container":"MapPageMap_container__6vgIb","map":"MapPageMap_map__B8vHw"};